import React, {useEffect, useState} from 'react';
import ApiService from './api/ApiService';
import  {Container,Typography} from "@mui/material";
import {renderDocs} from "./utils";

const Camp = () => {
    const [docs, setDocs] = useState([]);
    
    useEffect(() => {
        ApiService.getDocs('camp')
            .then((data) => {
                setDocs(data.docs);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    return (
         <Container>
            <Typography variant="h5" gutterBottom fontWeight={'bold'} align={'center'}
            sx={{
                mt: 2,
                textTransform: 'uppercase',
            }}>
                 Сведения об организации отдыха детей и их оздоровлении
            </Typography>
             {renderDocs(docs)}
        </Container>
    );
};

export default Camp;
